<!-- 销售订单出仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 20%">
                    配件名称
                </div>
                <div class="div-table-cell" style="width: 20%">
                    配件编码
                </div>
                <div class="div-table-cell flex" style="width: 60%">
                    <div class="border-right cell-item" style="width: 30%">
                        仓库
                    </div>
                    <div class="border-right cell-item" style="width: 30%">
                        仓位
                    </div>
                    <div class="border-right cell-item" style="width: 20%">
                        数量
                    </div>
                    <div class="cell-item" style="width: 20%">
                        
                    </div>
                </div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="(item,index) in goodsList" :key="item.EntpTempGoodsId">
                    <div class="div-table-cell" style="width: 20%">
                        {{item.GoodName}}
                    </div>
                    <div class="div-table-cell" style="width: 20%">
                        {{item.APCode}}
                    </div>
                    <div class="div-table-cell" style="width: 60%">
                        <!--循环仓库、仓位-->
                        <div class="cell-line" v-for="(warehouse,i) in item.GoodsLocationList" :key="i.key">
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select v-model="warehouse.WarehouseId"
                                           size="small"
                                           filterable
                                           clearable
                                           reserve-keyword 
                                           :loading="loading"
                                           @visible-change="wHVisibleChange($event,item)"
                                           @change="warehouseChange($event,item,warehouse)"
                                           no-data-text="无存放仓库"
                                >
                                    <el-option
                                            v-for="optionItem in item.WarehouseList"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId" 
                                            :key="optionItem.index"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select v-model="warehouse.ShelfSpaceId"
                                            size="small"
                                            :loading="loading"
                                            filterable
                                            clearable
                                            reserve-keyword
                                            remote
                                            :remote-method="
                                                (val) =>
                                                remoteMethod(val, warehouse.WarehouseId, warehouse,item.EntpTempGoodsId)
                                            "
                                           @change="positionChange($event,item,warehouse)"
                                           @visible-change="
                                            positionVisibleChange(
                                            $event,
                                            warehouse.WarehouseId,
                                            warehouse,
                                            item.EntpTempGoodsId
                                            )"
                                           no-data-text="无存放仓位"
                                           no-match-text="无存放仓位"
                                >
                                    <el-option
                                            v-for="optionItem in warehouse.ShelfSpacesList"
                                            :label="optionItem.ShelfSpaceCode"
                                            :value="optionItem.ShelfSpaceId"                                           
                                            :key="optionItem.index">
                                        <span style="display:inline-block;width: 150px">{{optionItem.ShelfSpaceCode}}</span>
                                        <span>库存:{{optionItem.Count}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 20%">
                                <el-input size="small"
                                          type="number"
                                          v-model="warehouse.Count"
                                          @blur="checkCount(warehouse.Count,warehouse.CountMax)"
                                          :max="warehouse.CountMax"
                                          :min="0"
                                          >
                                </el-input>
                            </div>
                            <div class="cell-item ops-ctn" style="width: 20%;;height:28px;margin-top: 7px;">
                                <el-button size="mini" icon="el-icon-minus" @click="delItem(index,i)"></el-button>
                            </div>
                        </div>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="add-btn" @click="addItem(index)"></el-button>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button size="small" @click="cancel" :disabled="dailogLoading">取消</el-button>
            <el-button class="btn-primary" size="small" :disabled="dailogLoading" @click="submitData">出仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
name: '',
props:['APList','EntpCusOId','OrderWarehouse'],//OrderWarehouse:订单选择的仓库
components: {

},
data(){
return {
    dailogLoading:true,
    loading: false,
    WarehouseList: [],
    PositionList: [],  
    searchPositionReq:{
        WarehouseId:"",
        ShelfSpaceCode: "",
        GoodsId: "",
        SortField: "SpaceType",
        SortType:"asc",
        Page:1,
        Limit:20
    } ,          
    formData:{
        EntpCusOId:this.EntpCusOId,
        GoodsList:[
            {
                EntpTempGoodsId:'',
                GoodsLocationList:[
                    {
                        ShelfSpaceId:'',
                        Count:'',
                    }
                ],
            }
        ]
    },
    goodsList:[]//入仓商品列表
}
},
mounted(){
   this.init();
},
methods:{   
    init(){
        let that = this;
        //仓位对象
        let spaceItem = {
            WarehouseId:'',
            ShelfSpaceCode:'',
            ShelfSpaceId:'',
            Count:'',
            CountMax:999,
            ShelfSpacesList:[]
        }
        //处理出仓数据 
        let _APList = [];
        for (let i = 0; i <that.APList.length;i++){
            if(!that.APList[i].IsDelivery){
                //可出仓数等于商品总数减去已经出仓数量
                spaceItem.Count=that.APList[i].Count-that.APList[i].WarehousedCount;
                spaceItem.WarehouseId="";
                //如果订单有选好仓库，则获取该仓库的仓位
                if(that.OrderWarehouse){
                    spaceItem.WarehouseId=that.OrderWarehouse.WarehouseId;
                }
                _APList.push({
                    EntpTempGoodsId:that.APList[i].EntpTempGoodsId,
                    GoodName:that.APList[i].GoodName,
                    APCode:that.APList[i].APCode,
                    Count:that.APList[i].Count,
                    WarehousedCount:that.APList[i].WarehousedCount,
                    GoodsLocationList:[{...spaceItem}],
                    WarehouseList: that.OrderWarehouse&&that.OrderWarehouse.WarehouseId?[{...that.OrderWarehouse}]:[],
                });
            }
        }
        that.goodsList = _APList;    
        that.dailogLoading=false;
    },
    //仓库下拉框出现/隐藏时触发
    wHVisibleChange(val, goods) {
      if (!val) return;
      let that = this;
      if (!goods.WarehouseList || goods.WarehouseList.length <=1) {
           that.loading = true;
        that.$util.getWarehouseByGId(goods.EntpTempGoodsId).then((data) => {
          let newW=data;
          let w=goods.WarehouseList.length>0?goods.WarehouseList[0]:"";
          if(w){
          let exit=data.find(e=>e.WarehouseId==w.WarehouseId);
            if(!exit){
              newW=goods.WarehouseList.concat(newW);
            }
          }
          that.$set(goods, "WarehouseList", newW);
          that.loading = false;
        });
      }
    }, 
    //仓位下拉框出现/隐藏时触发
    positionVisibleChange(val, warehouseId, warehouse,goodsId) {
      if (!val || !warehouseId) return;
      let that = this;
      if (
        !(warehouse.ShelfSpacesList && warehouse.ShelfSpacesList.length > 0)
      ) {
            that.searchPositionReq.WarehouseId=warehouseId;
            that.searchPositionReq.ShelfSpaceCode="";
            that.searchPositionReq.GoodsId=goodsId;
            that.searchPositionReq.Page=1;
            that.searchPosition(that.searchPositionReq).then((resp) => {
            let newArr=[];
            if(resp.data)newArr=resp.data;          
            that.$set(warehouse, "ShelfSpacesList", newArr);
            that.loading = false;
            });
      }
    },
    remoteMethod(val, warehouseId, warehouse,goodsId) {
      if (!val || !warehouseId) return;
      let that = this;
      that.searchPositionReq.WarehouseId=warehouseId;
      that.searchPositionReq.ShelfSpaceCode=val;
      that.searchPositionReq.GoodsId=goodsId;
      that.searchPositionReq.Page=1;   
      that.searchPosition(that.searchPositionReq).then((resp) => {
        let newArr=[];
        if(resp.data)newArr=resp.data;
        that.$set(warehouse, "ShelfSpacesList", newArr);
        that.loading = false;
      });
    },    
    // 搜仓位
    searchPosition(req) {
      let that = this;
      if (!req.WarehouseId || that.loading) return;
      that.loading = true;
      return that.$util.getPositionByGId(that.searchPositionReq);
    },    
    checkCount(count,max){
        if (count > max){
            this.$util.warningMsg('数量不得大于库存数量')
        }
    },
    cancel(){
        this.$emit('closeDialog')
    },
    submitData(){
        let _data = this.goodsList
        for (let i=0;i<_data.length;i++){
            //商品的可出仓数
            let PV = Number(_data[i].Count)-Number(_data[i].WarehousedCount)
            //已选仓位商品的出仓总数
            let EV = 0
            for (let j=0;j<_data[i].GoodsLocationList.length;j++){
                if (!_data[i].GoodsLocationList[j].ShelfSpaceId){
                    this.$util.warningMsg('请选择仓位')
                    return
                }
                let outCount=Number(_data[i].GoodsLocationList[j].Count)
                if(outCount<=0){
                    this.$util.warningMsg('出库数量必须大于零')
                    return
                }
                if(outCount > Number(_data[i].GoodsLocationList[j].CountMax)) {
                    this.$util.warningMsg('数量不得大于库存数量')
                    return
                }
                EV += outCount
            }
            if (PV <EV){
                this.$util.warningMsg('出库数量不可以超过未出库数量')
                return
            }
        }

        this.dailogLoading=true;
        this.formData.GoodsList = this.goodsList
        this.$util.axiosPost({
            url: '/api/EntpSaleOrder/ConfirmEntpSaleOrderOutWarehouse',
            data:this.formData,
            hideLoading:true,
        }).then((res)=>{
            let IsAllOutWarehouse = res.data.IsAllOutWarehouse
            this.$util.successMsg('出仓成功')
            this.$emit('closeDialog',true,IsAllOutWarehouse)
        }).catch(()=>{this.dailogLoading=false;})
    },
    //仓库的变换
    warehouseChange(value,goods,warehouse){
      warehouse.ShelfSpacesList = [];
      warehouse.ShelfSpaceId = "";
    },
    //仓位的变换:选中值、商品、仓库
    positionChange(value,goods,warehouse){
        if(!value)return;
        let that = this;
        let flag=0;
            goods.GoodsLocationList.forEach(e => {
                if(e.ShelfSpaceId==value){
                    flag++;
                    if(flag>1){
                        warehouse.ShelfSpaceId="";
                        that.$util.warningMsg('同个商品不能选相同仓位');
                        return;
                    }
                }
                if(warehouse.ShelfSpaceId==value){
                    warehouse.ShelfSpacesList.forEach(s=>{
                        if(s.ShelfSpaceId==value){
                            warehouse.CountMax=s.Count;
                            return;
                        }
                    });
                }   
            });   
    },
    delItem(index,i){
        let _data = {...this.goodsList[index]}
        if(_data.GoodsLocationList.length != 1){
            _data.GoodsLocationList.splice(i,1)
        }
        this.$set(this.goodsList,index,_data)
    },
    addItem(index){
        let that = this;
        //这是前一个选择的仓位
        let _target = that.goodsList[index].GoodsLocationList
        let usedCount=0;//已选数量
        for (let i=0;i<_target.length;i++){
            if (!_target[i].ShelfSpaceId){
                that.$util.warningMsg('请选择仓位')
                return
            }
            if (!_target[i].Count || !_target[i].Count < 0) {
                that.$util.warningMsg('请填写正确的数量')
                return
            }
            usedCount+=Number(_target[i].Count);
        }
        //当前商品
        let goods = {...that.goodsList[index]};
        //当前商品可入库数量
        let canInCount=Number(goods.Count)-Number(goods.WarehousedCount);
        //剩余数量
        let surplus=canInCount-usedCount
        let spaceItem={
            WarehouseId:'',
            ShelfSpaceCode:'',
            ShelfSpaceId:'',
            Count:surplus>0?surplus:0,
            ShelfSpacesList:[],
            WarehouseList: [{...goods.OrderWarehouse}],
        };

        //如果原来订单有选仓库，默认使用选好的仓库
        if(that.OrderWarehouse){
         spaceItem.WarehouseId=that.OrderWarehouse.WarehouseId;
        }
        goods.GoodsLocationList.push(spaceItem);
        that.$set(that.goodsList,index,goods);
    }
}
}
</script>
<style lang="less" scoped>
    .add-btn {
        position: absolute;
        right: 10px;
        bottom: 6px;
    }
    .ops-ctn {
        text-align: left !important;
    }
    .dialog-footer {
        text-align: right;
        margin-top: 20px;
    }
    .warehouseOut-main {
        padding-top: 20px;
    }
    .table-title {
        .cell-item {
            width: 33.33%;
        }
        .div-table-cell {
            text-align: center;
            height: 30px;
            line-height: 30px;
        }
    }
    .div-table-row {
        position: relative;
        overflow: visible;
    }
    .table-main {
        .div-table-cell {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        .cell-line {
            display: flex;
            width: 100%;
        }
        .cell-item {
            padding: 0 10px;
            width: 33%;
            width: inherit;
            text-align: center;
            height: 40px;
            line-height: 40px;
        }
    }
</style>
